const styles = {
  root: {},
  buttons: {
    '& .MuiButton-root:not(first-type)': {
      marginTop: 2,
    },
  },
  button: {
    '&.MuiButton-special': {
      padding: (theme) => theme.spacing(1.5),
      '&:hover': {
        background: '#0E9CBD!important',
      },
    },
  },
  disclaimerContainer: {
    marginTop: 1,
    padding: 1,
    borderRadius: 1,
  },
  easyCta: {
    height: '45px!important',
  },
}
export default styles
